// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/store.js";
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import {description} from '../package.json'

Vue.use(ElementUI);
Vue.use(VueMoment, {
  moment,
});
//启动时的生产提示
Vue.config.productionTip = false;
// axios
import axios from "axios";
import Qs from "qs";
axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];

function initApp() {
  let isLoggingOut = false;
  const CancelToken = axios.CancelToken;
  const cancelSource = CancelToken.source();

  let instance = null;
  let lineURL = localStorage.getItem("lineUrl");

  if (!lineURL) {
    localStorage.setItem("lineUrl", process.env.API_ROOT);
    localStorage.setItem("lineUrlText", "线路一");
    localStorage.setItem("lineUrlId", "1");

    instance = axios.create({
      baseURL: process.env.API_ROOT,
      timeout: 10000,
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
      }
    });
  } else {
    instance = axios.create({
      baseURL: lineURL,
      timeout: 10000,
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
      }
    });

    if (!localStorage.getItem("encript_public_key")) {
      localStorage.setItem(
        "encript_public_key",
        process.env.PUBLIC_ENCRYPTION_KEY
      );
    }
  }

  Vue.prototype.$http = instance;

  instance.interceptors.request.use(
    config => {
      config.cancelToken = cancelSource.token;
      return config;
    },
    error => Promise.reject(error)
  );

  instance.interceptors.response.use(
    response => {
      const res = response.data;

      if (res && res.code === -1) {
        if (!isLoggingOut) {
          isLoggingOut = true;
          cancelSource.cancel("Session expired");

          ElementUI.Message.error(res.msg || "登录失效，请重新登录");

          store.commit("changeLoginType", false);
          store.commit("clearStore");

          sessionStorage.clear();
          localStorage.clear();

          setTimeout(() => {
            router.push("/login");
            window.location.reload();
          }, 1000);
        }
        return Promise.reject(new Error(res.msg || "Session expired"));
      }

      return response;
    },
    error => {
      if (axios.isCancel(error)) {
        return new Promise(() => {});
      }
      return Promise.reject(error);
    }
  );

  const Line_1 = process.env.Line_1;
  const Line_2 = process.env.Line_2;

  Vue.prototype.$URLs = [
    { id: 1, name: "线路一", url: process.env.API_ROOT },
    { id: 2, name: "线路二", url: Line_1 },
    { id: 3, name: "线路三", url: Line_2 }
  ];

  Vue.prototype.$chatApiURL = "https://hkchatapp.hk9999z.com"; // TEST
  // Vue.prototype.$chatApiURL = "https://chat.hk2391.com"; // LIVE

  Vue.prototype.$dataSource = "shuhai";

  new Vue({
    el: "#app",
    router,
    store,
    render: h => h(App)
  });

  router.afterEach(() => {
    window.scrollTo(0, 0);
  });
}

initApp();



// WEBPACK FOOTER //
// ./src/main.js